<template>
  <div>
    <qr-code :size=300 error-level="H" :text=url>
    </qr-code>
  </div>
</template>

<script>
import VueQRCodeComponent from 'vue-qrcode-component';

export default {
  components: {
    'qr-code': VueQRCodeComponent
  }, 
  props: {
    url: String
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>

</style>
